import RadioGroup from "@p-ban/common/src/components/form/radio/RadioGroup"
import Spacer from "@p-ban/common/src/components/layout/Spacer"

import ESTIMATE_CONSTANT from "../../../../../constant/estimateConstant"
import FIELD_NAMES from "../../../../../constant/fieldNames"
import getDisplayCondition from "../../../../../service/getDisplayCondition"
import getNumberOfLayers from "../../../../../service/getNumberOfLayers"
import resolveAdhesiveSideName from "../../../../../service/sideNameResolver/resolveAdhesiveSideName"
import type { OneClickFieldProps } from "../../../../../types"
import FieldSet from "../../../../components/1Click/FieldSet"
import OneClickField from "../../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../../components/1Click/form/OneClickFieldStack"
import Radio from "../../../../components/1Click/form/Radio/Radio"
import HELP_LINKS from "../../../../constant/helpLinks"

import img from "./reinForcementCnt.png"

const 補強板厚み指定 = ({ values, handlers, errors }: OneClickFieldProps) => {
  const condition = getDisplayCondition(values)
  const { reinForcementCnt: shouldShow } = condition
  const shouldShow補強板厚み指定1箇所目 = condition.reinForcement1 && condition.reinForcementBonding1
  const shouldShow補強板厚み指定2箇所目 = condition.reinForcement2 && condition.reinForcementBonding2

  return (
    <OneClickField
      isShow={shouldShow}
      legend="補強板厚み指定"
      helpURL={HELP_LINKS.補強板厚み指定}
      src={img}
      mapChildren
    >
      <>
        <RadioGroup name={FIELD_NAMES.補強板厚み指定} selectedValue={values.reinForcementCnt} onChange={handlers.radio}>
          <OneClickFieldStack>
            <Radio value={ESTIMATE_CONSTANT.補強板厚み指定.なし.value}>なし</Radio>
            <Radio value={ESTIMATE_CONSTANT.補強板厚み指定["1箇所"].value}>1箇所</Radio>
            <Radio value={ESTIMATE_CONSTANT.補強板厚み指定["2箇所"].value}>2箇所</Radio>
            <Radio value={ESTIMATE_CONSTANT.補強板厚み指定["3箇所以上"].value}>3箇所以上</Radio>
          </OneClickFieldStack>
        </RadioGroup>
        <OneClickFieldMessages error={errors?.reinForcementCnt} />
      </>

      {shouldShow補強板厚み指定1箇所目 && (
        <_補強板厚み指定
          values={values}
          handlers={handlers}
          number={1}
          厚み指定={{
            name: FIELD_NAMES["厚み指定（1箇所目）"],
            selectedValue: values.reinForcement1,
            error: errors?.reinForcement1,
          }}
          接着面={{
            name: FIELD_NAMES["補強板厚み指定 接着面（1箇所目）"],
            selectedValue: values.reinForcementBonding1,
            error: errors?.reinForcementBonding1,
          }}
        />
      )}
      {shouldShow補強板厚み指定2箇所目 && (
        <_補強板厚み指定
          values={values}
          handlers={handlers}
          number={2}
          厚み指定={{
            name: FIELD_NAMES["厚み指定（2箇所目）"],
            selectedValue: values.reinForcement2,
            error: errors?.reinForcement2,
          }}
          接着面={{
            name: FIELD_NAMES["補強板厚み指定 接着面（2箇所目）"],
            selectedValue: values.reinForcementBonding2,
            error: errors?.reinForcementBonding2,
          }}
        />
      )}
    </OneClickField>
  )
}

export default 補強板厚み指定

type Props = OneClickFieldProps & {
  number: 1 | 2
  厚み指定: {
    name: string
    selectedValue: string
    error?: string
  }
  接着面: {
    name: string
    selectedValue: string
    error?: string
  }
}

const _補強板厚み指定 = ({ values, handlers, number, 厚み指定, 接着面 }: Props) => {
  const numberOfLayers = getNumberOfLayers(values)

  const id = (() => {
    if (numberOfLayers === 1) return "片面"
    if (numberOfLayers === 2) return "2層"
    if (numberOfLayers === 3) return "3層"
    if (numberOfLayers === 4) return "4層"
  })()
  if (!id) return null

  return (
    <>
      <FieldSet legend={`厚み指定 （${number}箇所目）`}>
        <RadioGroup name={厚み指定.name} selectedValue={厚み指定.selectedValue} onChange={handlers.radio}>
          <OneClickFieldStack>
            <Radio value={ESTIMATE_CONSTANT.厚み指定["0.1mmPI"].value}>0.1mmPI</Radio>
            <Radio value={ESTIMATE_CONSTANT.厚み指定["0.15mmPI"].value}>0.15mmPI</Radio>
            <Radio value={ESTIMATE_CONSTANT.厚み指定["0.2mmPI"].value}>0.2mmPI</Radio>
            <Radio value={ESTIMATE_CONSTANT.厚み指定["0.25mmPI"].value}>0.25mmPI</Radio>
            <Radio value={ESTIMATE_CONSTANT.厚み指定["0.2mmFR-4"].value}>0.2mmFR-4</Radio>
            <Radio value={ESTIMATE_CONSTANT.厚み指定["0.4mmFR-4"].value}>0.4mmFR-4</Radio>
            <Radio value={ESTIMATE_CONSTANT.厚み指定["1.0mmFR-4"].value}>1.0mmFR-4</Radio>
            <Radio value={ESTIMATE_CONSTANT.厚み指定["1.6mmFR-4"].value}>1.6mmFR-4</Radio>
            <Radio value={ESTIMATE_CONSTANT.厚み指定.ステンレス.value}>ステンレス</Radio>
          </OneClickFieldStack>
        </RadioGroup>
      </FieldSet>
      <OneClickFieldMessages error={厚み指定.error} />
      <Spacer size={8} />
      <FieldSet legend={`接着面 （${number}箇所目）`}>
        <RadioGroup name={接着面.name} selectedValue={接着面.selectedValue} onChange={handlers.radio}>
          <OneClickFieldStack>
            <Radio value={ESTIMATE_CONSTANT.接着面[`パターン面と同じ面(L1面)(${id})`].value}>
              {resolveAdhesiveSideName(ESTIMATE_CONSTANT.接着面[`パターン面と同じ面(L1面)(${id})`].value, values)}
            </Radio>
            <Radio value={ESTIMATE_CONSTANT.接着面[`パターン面とは逆の面(Ln面)(${id})`].value}>
              {resolveAdhesiveSideName(ESTIMATE_CONSTANT.接着面[`パターン面とは逆の面(Ln面)(${id})`].value, values)}
            </Radio>
          </OneClickFieldStack>
        </RadioGroup>
      </FieldSet>
      <OneClickFieldMessages error={接着面.error} />
    </>
  )
}
